import ReadTaskView from './ReadTaskViewContainer';
export default ReadTaskView;
